import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { updatePageSEO, getSiteUrl } from '../../utils/seo';

const allStyles = [
  {
    id: 1,
    title: 'ナチュラルショートボブ',
    category: 'ショート',
    description: '大人の女性に人気のショートボブスタイル。軽やかで扱いやすく、どんなシーンにも対応できます。岡山市の美容室おかやま美容室で人気のスタイルです。',
    image: 'https://public.readdy.ai/ai/img_res/b670e59e0c13d2eee2113c258d34644b.jpg',
  },
  {
    id: 2,
    title: 'ふんわりミディアムレイヤー',
    category: 'ミディアム',
    description: '柔らかな動きが魅力のミディアムレイヤー。女性らしさを引き立てる人気のスタイルです。',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20japanese%20woman%20with%20soft%20medium%20layered%20hairstyle%2C%20natural%20wavy%20hair%20with%20gentle%20volume%2C%20warm%20brown%20hair%20color%2C%20simple%20clean%20background%20in%20soft%20beige%20tones%2C%20elegant%20asian%20woman%20with%20flowing%20medium%20length%20hair%2C%20professional%20salon%20photography%20in%20okayama&width=600&height=800&seq=style102&orientation=portrait',
  },
  {
    id: 3,
    title: 'エレガントロング',
    category: 'ロング',
    description: 'ツヤ感のある美しいロングヘア。上品で洗練された印象を与えるスタイルです。',
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20japanese%20woman%20with%20elegant%20long%20straight%20hair%2C%20glossy%20healthy%20hair%20with%20natural%20shine%2C%20dark%20brown%20hair%20color%2C%20minimalist%20clean%20background%20in%20warm%20neutral%20tones%2C%20graceful%20asian%20woman%20showing%20beautiful%20long%20hairstyle%2C%20professional%20beauty%20salon%20photography%20in%20okayama&width=600&height=800&seq=style103&orientation=portrait',
  },
  {
    id: 4,
    title: 'カジュアルウェーブ',
    category: 'ミディアム',
    description: '自然な動きが魅力のウェーブスタイル。リラックスした雰囲気を演出します。',
    image: 'https://readdy.ai/api/search-image?query=cheerful%20japanese%20woman%20with%20casual%20wavy%20hairstyle%2C%20natural%20beach%20waves%20with%20soft%20texture%2C%20light%20brown%20hair%20with%20natural%20highlights%2C%20simple%20clean%20background%20in%20soft%20cream%20tones%2C%20friendly%20asian%20woman%20with%20relaxed%20wavy%20hair%2C%20professional%20hair%20salon%20photography%20in%20okayama&width=600&height=800&seq=style104&orientation=portrait',
  },
  {
    id: 5,
    title: 'クールショート',
    category: 'ショート',
    description: 'スタイリッシュで洗練されたショートヘア。個性を引き立てるモダンなスタイルです。',
    image: 'https://readdy.ai/api/search-image?query=confident%20japanese%20woman%20with%20cool%20short%20pixie%20hairstyle%2C%20modern%20edgy%20haircut%20with%20clean%20lines%2C%20dark%20hair%20color%20with%20subtle%20texture%2C%20simple%20clean%20background%20in%20soft%20grey%20tones%2C%20stylish%20asian%20woman%20with%20contemporary%20short%20hair%2C%20professional%20beauty%20photography%20in%20okayama%20salon&width=600&height=800&seq=style105&orientation=portrait',
  },
  {
    id: 6,
    title: 'フェミニンミディ',
    category: 'ミディアム',
    description: '女性らしい柔らかさを演出するミディアムスタイル。どんな場面でも好印象を与えます。',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/a8e26d6d0db5b410859282e31fa48915.jpeg',
  },
  {
    id: 7,
    title: 'グラマラスロング',
    category: 'ロング',
    description: 'ボリューム感のある華やかなロングヘア。特別な日にもぴったりのスタイルです。',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/757611c0b5b5757abb557cfd8989e1f4.jpeg',
  },
  {
    id: 8,
    title: 'ナチュラルボブ',
    category: 'ショート',
    description: 'シンプルで扱いやすいボブスタイル。幅広い年齢層に支持される定番スタイルです。',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/2d2113dca9e909bbb26f469e313c3340.jpeg',
  },
  {
    id: 9,
    title: 'レイヤードミディアム',
    category: 'ミディアム',
    description: '動きのあるレイヤーが特徴のミディアムスタイル。軽やかで爽やかな印象を与えます。',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/ac94c6588e029dff23ddbd71c6165543.jpeg',
  },
  {
    id: 10,
    title: 'ストレートロング',
    category: 'ロング',
    description: '清潔感のあるストレートロングヘア。シンプルながらも美しいスタイルです。',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/8dc84880733a66ce99e3bb104ab8a3e7.jpeg',
  },
  {
    id: 11,
    title: 'エアリーショート',
    category: 'ショート',
    description: '軽やかで動きのあるショートスタイル。若々しい印象を演出します。',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/760256ed6daa4776652f278271d8e8fa.jpeg',
  },
  {
    id: 12,
    title: 'カールミディアム',
    category: 'ミディアム',
    description: '華やかなカールが魅力のミディアムスタイル。特別な日にもおすすめです。',
    image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/d4df1023be11f812774149a5612119ba.jpeg',
  },
];

const categories = ['すべて', 'ショート', 'ミディアム', 'ロング'];

export default function StylePage() {
  const [selectedCategory, setSelectedCategory] = useState('すべて');

  useEffect(() => {
    const siteUrl = getSiteUrl();
    updatePageSEO({
      title: 'スタイル紹介 | おかやま美容室 - 岡山市北区の美容室',
      description: '岡山市北区の美容室おかやま美容室のヘアスタイル紹介。ショート、ミディアム、ロングなど、お客様一人ひとりの個性や魅力を引き出すヘアスタイルをご提案。最新トレンドから定番スタイルまで幅広くご用意しています。',
      keywords: '岡山市 美容室, おかやま美容室, ヘアスタイル, ショート, ミディアム, ロング, ヘアカタログ',
      canonical: `${siteUrl}/style`,
      ogTitle: 'スタイル紹介 | おかやま美容室 - 岡山市北区の美容室',
      ogDescription: '岡山市北区の美容室おかやま美容室のヘアスタイル紹介。ショート、ミディアム、ロングなど幅広くご用意。',
      ogType: 'website',
      ogUrl: `${siteUrl}/style`,
      ogImage: 'https://readdy.ai/api/search-image?query=elegant-japanese-hair-salon-styling-okayama&width=1200&height=630&seq=ogstyle&orientation=landscape',
      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: 'スタイル紹介',
        description: '岡山市北区の美容室おかやま美容室のヘアスタイル紹介。ショート、ミディアム、ロングなど幅広くご用意。',
        url: `${siteUrl}/style`,
        publisher: {
          '@type': 'Organization',
          name: 'おかやま美容室株式会社',
          url: siteUrl,
        },
      },
    });
  }, []);

  const filteredStyles = selectedCategory === 'すべて'
    ? allStyles
    : allStyles.filter(style => style.category === selectedCategory);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative h-96 sm:h-[500px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=elegant%20japanese%20hair%20salon%20styling%20area%20in%20okayama%20with%20beautiful%20hairstyle%20examples%2C%20modern%20beauty%20salon%20interior%20showcasing%20various%20haircuts%20and%20styles%2C%20professional%20hairdressing%20space%20with%20styling%20chairs%20and%20large%20mirrors%2C%20contemporary%20salon%20design%20with%20natural%20lighting%20and%20plants&width=1920&height=1000&seq=stylepage001&orientation=landscape"
              alt="スタイル紹介 - 岡山市の美容室おかやま美容室"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
          </div>
          <div className="relative z-10 text-center px-4">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-wider" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              STYLE
            </h1>
            <p className="text-base sm:text-lg text-white tracking-widest" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              スタイル紹介
            </p>
          </div>
        </section>

        {/* Style Gallery */}
        <section className="py-16 sm:py-20 lg:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 sm:mb-16">
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed max-w-3xl mx-auto">
                岡山市の美容室おかやま美容室では、お客様一人ひとりの個性や魅力を引き出すヘアスタイルをご提案しています。<br className="hidden sm:block" />
                最新のトレンドから定番スタイルまで、幅広いスタイルをご用意しております。
              </p>
            </div>

            {/* Category Filter */}
            <div className="flex flex-wrap gap-3 justify-center mb-12 sm:mb-16">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-2 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-gray-900 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {category}
                </button>
              ))}
            </div>

            {/* Style Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8">
              {filteredStyles.map((style) => (
                <article key={style.id} className="group cursor-pointer">
                  <div className="relative h-80 sm:h-96 rounded-lg overflow-hidden mb-4 shadow-md group-hover:shadow-xl transition-all duration-300">
                    <img
                      src={style.image}
                      alt={`${style.title} - 岡山市の美容室おかやま美容室`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-4 right-4">
                      <span className="px-3 py-1 bg-white text-gray-900 text-xs font-medium rounded-full shadow-md">
                        {style.category}
                      </span>
                    </div>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-gray-900 tracking-wider" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    {style.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {style.description}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 sm:py-20 bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6 tracking-wider" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              理想のスタイルを実現しませんか？
            </h2>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-8 sm:mb-12">
              岡山市の美容室おかやま美容室では、お客様のご要望に合わせた<br className="hidden sm:block" />
              最適なヘアスタイルをご提案いたします。お気軽にご相談ください。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:086-012-3456"
                className="inline-flex items-center px-8 py-4 bg-gray-900 text-white text-sm font-semibold rounded-full hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer justify-center"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                086-012-3456
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-gray-900 text-gray-900 text-sm font-semibold rounded-full hover:bg-gray-900 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer justify-center"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                <i className="ri-mail-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                お問い合わせ
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
